import React from "react";
import "../styles/info.css";

const Tag = ({ tag }) => {
  return <li className="tag-info"> {tag} </li>;
};

export default Tag;
